export default __webpack_public_path__ + "static/media/2019_2.db7941de.jpg";